import angular from 'angular';
import Viewport from 'cars-ng-browser/lib/viewport';
import Storage from 'cars-ng-browser/lib/storage';
import History from 'cars-ng-browser/lib/history';

export default angular.module('cars.browser', [
    Viewport,
    Storage,
    History
])
    .config([() => {}])
    .name;